import { MediaAdminService } from 'app/API';
import type { TCall } from 'app/queries/types/TCall';

type TParams = {
  jobId: string;
  file: string;
};

export const fetchSignedMediaDownloadUrl = (call: TCall, { jobId, file }: TParams) =>
  call(() => MediaAdminService.adminGetSignedUrl({ jobId, file, disposition: 'attachment' }));
